define('bindingHandlers/attr',[
    'lib/knockout'
], function (ko) {

    'use strict';

    // retained reference to original binding

    var originalAttrBinding = ko.bindingHandlers.attr;

    /**
     * attr Binding Handler (wrapper)
     *
     * We're using our own attr binding to wrap the original binding
     * to fix an issue in IE where host and hostname are lost for
     * dynamically bound, relative links resulting in the hashchange
     * event not fire correctly.
     */

    ko.bindingHandlers.attr = {

        init: originalAttrBinding.init,

        update: function(element, valueAccessor){

            // apply original update method

            originalAttrBinding.update.apply(this, arguments);

            var bindingData = ko.unwrap(valueAccessor()) || {};

            // If href is beinging bound, make sure that host and hostname are retained.
            // IE doesn't retain these for dynamic, relative links.

            if(bindingData.href){

                element.host = (element.host.length === 0) ? window.location.host : element.host;
                element.hostname = (element.hostname.length === 0) ? window.location.hostname : element.hostname;
            }

        }

    };

});
